import React, { createContext, useState, Fragment, useContext, useEffect } from 'react';
import { CustomModal } from '../../components/modal/modalBase';
import { CloseButton } from '../../components';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [activeModal, setActiveModal] = useState('');
    const [params, setParams] = useState({});
    const [styles, setStyles] = useState({});

    return (
        <Fragment>
            <ModalContext.Provider
                value={{
                    activeModal,
                    setActiveModal,
                    params,
                    setParams,
                    setStyles,
                    styles,
                }}
            >
                {children}
            </ModalContext.Provider>
        </Fragment>
    );
};

export const useModal = () => {
    const { setActiveModal, params, setParams, styles, setStyles } = useContext(ModalContext);

    return {
        open: (params = {}, styles) => {
            setActiveModal(true);
            setParams(params);
            setStyles(styles);
        },
        close: () => {
            setActiveModal('');
            setParams({});
            setStyles({});
        },
        params,
        styles,
    };
};

export const AllModals = () => {
    const { activeModal } = useContext(ModalContext);
    const { close, params, styles } = useModal();

    useEffect(() => {
        if (activeModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [activeModal]);

    return (
        <CustomModal
            handleOpenClose={() => close('')}
            openDefault={activeModal ? activeModal : false}
            content={
                <div style={{ outline: 'none', ...styles?.styles?.wrapperStyle }} className="modal-wrapper-style open-sans">
                    <div className="modal-header-style" style={{ ...styles?.styles?.headerStyle }}>
                        <CloseButton handleCLic={close} />
                    </div>
                    <div style={styles?.styles?.bodyStyle ? { ...styles?.styles?.bodyStyle } : {}} className="modal-body-style">
                        {params}
                    </div>
                </div>
            }
        />
    );
};
